module.exports = __webpack_public_path__ + "static/media/empty-project.fa2cd2ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-project.svg
// module id = 221
// module chunks = 0